// Path: ./src/app/components/SmallDealImgCard/styled.ts
import styled from "styled-components";

export const CancelButton = styled.div`
  position: absolute;
  top: -12px;
  right: -8px;
  display: none;
`;

export const EditButton = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  display: none;
`;

export const TagButton = styled.div`
  position: absolute;
  bottom: 4px;
  right: 36px;
  display: none;
`;

export const Image = styled.img`
  width: 90%;
  margin: 0 auto;
  height: 110px;
  display: flex;
  object-fit: contain;
`;

export const Card = styled.div`
  width: 100%;
  height: 130px;
  border-radius: 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 14px -5px #00000033;
  background-color: #8080804a;
`;
export const Container = styled.div`
  position: relative;
  &:hover ${CancelButton} {
    display: block;
  }
  &:hover ${EditButton} {
    display: block;
  }
  &:hover ${TagButton} {
    display: block;
  }
`;
